/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1dbb07e4"]'><cube-button outline scope="userInfo" tip="需在小程序环境下预览" @getUserInfo='(e)=>__invoke(e, [["onGetUserInfo"]])'>获取用户信息</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1dbb07e4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1dbb07e4"}
  /** script content **/
  require("./btn-get-user-info.mpx.js?isComponent&outputPath=components%2Fbtn-get-user-info1dbb07e4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-get-user-info.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-get-user-info1dbb07e4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1dbb07e4"],
    ctorType: "component",
    outputPath: "components/btn-get-user-info1dbb07e4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>